import React from "react";
import { FormikProps } from "formik";
import {
  FiUser,
  FiMail,
  FiPhone,
  FiCreditCard,
  FiMapPin,
  FiUpload,
  FiX,
} from "react-icons/fi";
import { RegisterFormValues } from "./Register";

interface RegisterFormProps {
  formik: FormikProps<RegisterFormValues>;
  showPassword: boolean;
  setShowPassword: (show: boolean) => void;
  fileInputRef: React.RefObject<HTMLInputElement>;
  handleRemoveImage: () => void;
  fileToBase64: (file: File) => Promise<string>;
  registerLoading: boolean;
  registerError: string | null;
  registerSuccessMessage: string | null;
}

const RegisterForm: React.FC<RegisterFormProps> = ({
  formik,
  // showPassword,
  // setShowPassword,
  fileInputRef,
  handleRemoveImage,
  fileToBase64,
  registerLoading,
  registerError,
  registerSuccessMessage,
}) => {
  return (
    <form onSubmit={formik.handleSubmit} className="space-y-5 mt-6 w-full">
      
      {/* Full Name */}
      <div className="space-y-1.5">
        <label className="text-xs font-semibold text-gray-500 tracking-wide ml-1 uppercase">
          Full Name <span className="text-red-500">*</span>
        </label>
        <div className="relative group transition-all duration-300 focus-within:-translate-y-1">
          <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none text-gray-400 group-focus-within:text-violet-600 transition-colors">
            <FiUser size={18} />
          </div>
          <input
            name="fullName"
            value={formik.values.fullName}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            placeholder="Enter Full Name"
            className="block w-full pl-11 pr-4 py-3.5 bg-gray-50 border border-gray-100 rounded-2xl text-gray-700 placeholder-gray-400 focus:outline-none focus:ring-4 focus:ring-violet-500/10 focus:border-violet-500/50 focus:bg-white transition-all duration-300 text-sm font-medium shadow-sm hover:shadow-md"
          />
        </div>
        {formik.touched.fullName && formik.errors.fullName && (
          <p className="text-red-500 text-xs mt-1 ml-1">{formik.errors.fullName as string}</p>
        )}
      </div>

      {/* Email & Mobile Split */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
        <div className="space-y-1.5">
          <label className="text-xs font-semibold text-gray-500 tracking-wide ml-1 uppercase">
            Email <span className="text-red-500">*</span>
          </label>
          <div className="relative group transition-all duration-300 focus-within:-translate-y-1">
            <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none text-gray-400 group-focus-within:text-violet-600 transition-colors">
              <FiMail size={18} />
            </div>
            <input
              name="email"
              type="email"
              value={formik.values.email}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              placeholder="user@example.com"
              className="block w-full pl-11 pr-4 py-3.5 bg-gray-50 border border-gray-100 rounded-2xl text-gray-700 placeholder-gray-400 focus:outline-none focus:ring-4 focus:ring-violet-500/10 focus:border-violet-500/50 focus:bg-white transition-all duration-300 text-sm font-medium shadow-sm hover:shadow-md"
            />
          </div>
          {formik.touched.email && formik.errors.email && (
            <p className="text-red-500 text-xs mt-1 ml-1">{formik.errors.email as string}</p>
          )}
        </div>

        <div className="space-y-1.5">
          <label className="text-xs font-semibold text-gray-500 tracking-wide ml-1 uppercase">
            Mobile <span className="text-red-500">*</span>
          </label>
          <div className="relative group transition-all duration-300 focus-within:-translate-y-1">
            <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none text-gray-400 group-focus-within:text-violet-600 transition-colors">
              <FiPhone size={18} />
            </div>
            <input
              name="mobile"
              value={formik.values.mobile}
              onChange={(e) => {
                const value = e.target.value.replace(/\D/g, ""); // Remove non-digits
                if (value.length <= 10) {
                  formik.setFieldValue("mobile", value);
                }
              }}
              onBlur={formik.handleBlur}
              placeholder="9999999999"
              maxLength={10}
              className="block w-full pl-11 pr-4 py-3.5 bg-gray-50 border border-gray-100 rounded-2xl text-gray-700 placeholder-gray-400 focus:outline-none focus:ring-4 focus:ring-violet-500/10 focus:border-violet-500/50 focus:bg-white transition-all duration-300 text-sm font-medium shadow-sm hover:shadow-md"
            />
          </div>
          {formik.touched.mobile && formik.errors.mobile && (
            <p className="text-red-500 text-xs mt-1 ml-1">{formik.errors.mobile as string}</p>
          )}
        </div>
      </div>

      {/* Password */}
      {/* <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
        <div className="space-y-1.5">
          <label className="text-xs font-semibold text-gray-500 tracking-wide ml-1 uppercase">
            Password
          </label>
          <div className="relative group transition-all duration-300 focus-within:-translate-y-1">
            <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none text-gray-400 group-focus-within:text-violet-600 transition-colors">
              <FiLock size={18} />
            </div>
            <input
              name="password"
              type={showPassword ? "text" : "password"}
              value={formik.values.password}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              placeholder="Create a strong password"
              autoComplete="new-password"
              className="block w-full pl-11 pr-12 py-3.5 bg-gray-50 border border-gray-100 rounded-2xl text-gray-700 placeholder-gray-400 focus:outline-none focus:ring-4 focus:ring-violet-500/10 focus:border-violet-500/50 focus:bg-white transition-all duration-300 text-sm font-medium shadow-sm hover:shadow-md"
            />
            <button
              type="button"
              onClick={() => setShowPassword(!showPassword)}
              className="absolute inset-y-0 right-0 pr-4 flex items-center text-gray-400 hover:text-violet-600 transition-colors cursor-pointer focus:outline-none"
              tabIndex={-1}
            >
              {showPassword ? <FiEyeOff size={18} /> : <FiEye size={18} />}
            </button>
          </div>
          {formik.touched.password && formik.errors.password && (
            <p className="text-red-500 text-xs mt-1 ml-1">{formik.errors.password as string}</p>
          )}
        </div>

        <div className="space-y-1.5">
          <label className="text-xs font-semibold text-gray-500 tracking-wide ml-1 uppercase">
            Confirm Password
          </label>
          <div className="relative group transition-all duration-300 focus-within:-translate-y-1">
            <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none text-gray-400 group-focus-within:text-violet-600 transition-colors">
              <FiLock size={18} />
            </div>
            <input
              name="confirmPassword"
              type={showPassword ? "text" : "password"}
              value={formik.values.confirmPassword}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              placeholder="Confirm your password"
              autoComplete="new-password"
              className="block w-full pl-11 pr-12 py-3.5 bg-gray-50 border border-gray-100 rounded-2xl text-gray-700 placeholder-gray-400 focus:outline-none focus:ring-4 focus:ring-violet-500/10 focus:border-violet-500/50 focus:bg-white transition-all duration-300 text-sm font-medium shadow-sm hover:shadow-md"
            />
          </div>
          {formik.touched.confirmPassword && formik.errors.confirmPassword && (
            <p className="text-red-500 text-xs mt-1 ml-1">{formik.errors.confirmPassword as string}</p>
          )}
        </div>
      </div> */}

      {/* IDs Split */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
        <div className="space-y-1.5">
          <label className="text-xs font-semibold text-gray-500 tracking-wide ml-1 uppercase">
            Aadhaar Number
          </label>
          <div className="relative group transition-all duration-300 focus-within:-translate-y-1">
            <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none text-gray-400 group-focus-within:text-violet-600 transition-colors">
              <FiCreditCard size={18} />
            </div>
            <input
              name="aadharNumber"
              value={formik.values.aadharNumber}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              placeholder="12-digit number"
              className="block w-full pl-11 pr-4 py-3.5 bg-gray-50 border border-gray-100 rounded-2xl text-gray-700 placeholder-gray-400 focus:outline-none focus:ring-4 focus:ring-violet-500/10 focus:border-violet-500/50 focus:bg-white transition-all duration-300 text-sm font-medium shadow-sm hover:shadow-md"
            />
          </div>
        </div>

        <div className="space-y-1.5">
          <label className="text-xs font-semibold text-gray-500 tracking-wide ml-1 uppercase">
            PAN Number
          </label>
          <div className="relative group transition-all duration-300 focus-within:-translate-y-1">
            <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none text-gray-400 group-focus-within:text-violet-600 transition-colors">
              <FiCreditCard size={18} />
            </div>
            <input
              name="panNumber"
              value={formik.values.panNumber}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              placeholder="10-digit PAN"
              className="block w-full pl-11 pr-4 py-3.5 bg-gray-50 border border-gray-100 rounded-2xl text-gray-700 placeholder-gray-400 focus:outline-none focus:ring-4 focus:ring-violet-500/10 focus:border-violet-500/50 focus:bg-white transition-all duration-300 text-sm font-medium shadow-sm hover:shadow-md"
            />
          </div>
        </div>
      </div>

      {/* Address */}
      <div className="space-y-1.5">
        <label className="text-xs font-semibold text-gray-500 tracking-wide ml-1 uppercase">
          Address
        </label>
        <div className="relative group transition-all duration-300 focus-within:-translate-y-1">
          <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none text-gray-400 group-focus-within:text-violet-600 transition-colors">
            <FiMapPin size={18} />
          </div>
          <input
            name="address"
            value={formik.values.address}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            placeholder="Your complete address"
            className="block w-full pl-11 pr-4 py-3.5 bg-gray-50 border border-gray-100 rounded-2xl text-gray-700 placeholder-gray-400 focus:outline-none focus:ring-4 focus:ring-violet-500/10 focus:border-violet-500/50 focus:bg-white transition-all duration-300 text-sm font-medium shadow-sm hover:shadow-md"
          />
        </div>
      </div>

      {/* Profile Image */}
      <div className="space-y-1.5">
        <label className="text-xs font-semibold text-gray-500 tracking-wide ml-1 uppercase">
          Profile Image
        </label>
        <div className="flex items-center gap-4">
          <div className="relative flex-1 group transition-all duration-300">
            <input
              type="file"
              accept="image/*"
              ref={fileInputRef}
              className="hidden"
              onChange={async (e) => {
                const file = e.currentTarget.files?.[0];
                if (!file) {
                  formik.setFieldValue("profileImage", "");
                  formik.setFieldValue("imgExtenstion", "");
                  return;
                }
                const base64 = await fileToBase64(file);
                const parts = base64.split(",");
                const pureBase64 = parts.length > 1 ? parts[1] : parts[0];
                const ext = file.name.split(".").pop()?.toLowerCase() || "";

                formik.setFieldValue("profileImage", pureBase64);
                formik.setFieldValue("imgExtenstion", ext);
              }}
            />
            <button
              type="button"
              onClick={() => fileInputRef.current?.click()}
              className="w-full flex items-center justify-center gap-2 px-4 py-3.5 border-2 border-dashed border-gray-300 rounded-2xl text-gray-600 hover:border-violet-500 hover:text-violet-600 hover:bg-violet-50/50 transition-all bg-gray-50/50 shadow-sm hover:shadow-md text-sm font-medium"
            >
              <FiUpload size={18} />
              {formik.values.imgExtenstion
                ? "Change Image"
                : "Upload Profile Picture"}
            </button>
          </div>
          {formik.values.imgExtenstion && (
            <div className="flex items-center gap-2 bg-violet-50 text-violet-700 px-3 py-1.5 rounded-xl text-xs font-semibold border border-violet-100 shadow-sm">
              <span className="uppercase">{formik.values.imgExtenstion}</span>
              <button
                type="button"
                onClick={handleRemoveImage}
                className="p-1 hover:bg-violet-100 rounded-full transition-colors"
                title="Remove image"
              >
                <FiX size={14} />
              </button>
            </div>
          )}
        </div>
      </div>

      {(registerError || registerSuccessMessage) && (
        <div
          className={`mt-4 rounded-xl shadow-sm px-4 py-3 text-sm font-medium backdrop-blur-sm animate-pulse-soft border ${
            registerError
              ? "bg-red-50/80 border-red-100 text-red-600"
              : "bg-emerald-50/80 border-emerald-100 text-emerald-600"
          }`}
        >
            <p>{registerError || registerSuccessMessage}</p>
        </div>
      )}

      <button
        type="submit"
        disabled={registerLoading}
        className="w-full flex justify-center items-center py-4 px-4 border border-transparent rounded-2xl shadow-lg shadow-violet-500/20 text-sm font-bold text-white bg-gradient-to-r from-violet-600 to-indigo-600 hover:from-violet-700 hover:to-indigo-700 focus:outline-none focus:ring-4 focus:ring-violet-500/20 disabled:opacity-50 disabled:cursor-not-allowed transform transition-all active:scale-[0.98] duration-300 hover:shadow-violet-500/30 mt-4"
      >
        {registerLoading ? (
            <span className="flex items-center gap-2">
            <svg
              className="animate-spin h-5 w-5 text-white/90"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle
                className="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                strokeWidth="4"
              ></circle>
              <path
                className="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
              ></path>
            </svg>
            <span className="tracking-wide">Creating Account...</span>
          </span>
        ) : (
             "Create Account"
        )}
      </button>
    </form>
  );
};

export default RegisterForm;
